var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampfirePoints5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 120,
    viewBox: "10 0 60 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.425 110.773C41.425 110.773 52.2249 109.367 58.2083 104.098C64.1917 98.8289 70.7561 88.8152 70.0268 75.4684C69.2975 62.1215 66.9914 61.7982 66.9914 61.7982C66.9914 61.7982 64.7727 67.0384 61.9998 65.6319C59.227 64.2253 61.8313 49.8126 56.8693 41.5544C53.0912 39.0688 47.9662 35.4524 45.0191 30.6913C40.6483 23.6303 41.425 13.657 41.425 13.657C41.425 13.657 30.5438 26.132 28.7118 38.6231C27.032 65.4992 28.8737 70.6646 23.909 70.6646C18.9442 70.6646 18.0716 58.0804 18.0716 58.0804C18.0716 58.0804 11.3577 69.4965 11.6499 77.7513C11.9421 86.0061 20.9928 99.1806 20.9928 99.1806L16.0309 97.9539C16.0309 97.9539 24.055 110.773 41.425 110.773Z",
    fill: "url(#paint0_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.6357 54.2938C17.6357 54.2938 21.5265 49.5475 22.4195 46.7723C23.3124 43.9971 23.6315 37.9369 23.185 38.3751C18.0822 43.1943 17.7198 47.7412 17.6357 54.2938Z",
    fill: "#FF6320"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0112 112.361C36.0112 112.361 45.8494 115.939 54.264 106.278C59.2275 100.627 63.7023 94.2034 67.5997 87.1343L60.8675 89.4622C60.8675 89.4622 60.7367 79.9771 62.4198 74.2527C64.1028 68.5283 64.2316 64.045 57.4563 70.6882C56.5856 71.5418 50.2508 69.0622 51.8045 54.7515C53.3581 40.4409 43.5666 36.4949 37.7416 28.2691C37.7416 36.1417 30.8346 36.1446 30.1862 50.4571C29.5378 64.7695 28.5136 91.7891 14.1387 71.9266C14.1387 91.0701 25.3965 110.571 36.0112 112.361Z",
    fill: "#FE9A3D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9614 110.16C45.3468 112.861 59.529 104.92 60.2842 93.4739C61.5119 86.9765 57.1914 82.7617 53.6633 79.2491C44.106 70.2634 36.4648 54.5115 38.9614 37.7363C20.4153 57.8883 42.8123 67.1005 32.4317 81.3013C26.9076 85.8674 22.096 82.2652 21.3292 85.251C20.5624 88.2368 28.0695 109.457 38.9614 110.16Z",
    fill: "#FFB22D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5282 108.76C50.2033 108.614 53.2356 97.1625 52.0087 91.0171C50.7818 84.8718 45.518 76.9662 44.9046 69.59C44.2911 62.2137 46.037 58.7207 46.037 58.7207C46.037 58.7207 39.7511 71.0636 38.4436 76.8587C37.1362 82.6538 39.2946 89.9636 36.2265 91.0171C33.1585 92.0706 28.067 88.0314 29.2962 91.0171C30.5254 94.0029 33.2513 108.932 42.5282 108.76Z",
    fill: "#FFE840"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4423 106.809C45.0349 106.809 46.3087 97.1497 45.982 92.9508C45.6553 88.752 41.1528 81.8218 41.4423 79.7219C41.7317 77.622 40.6429 89.3807 38.6812 91.0602C36.7194 92.7398 34.7585 93.3659 35.5211 97.1488C36.2836 100.932 38.1832 106.809 41.4423 106.809Z",
    fill: "#FDFBE6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 7.64062,
    y: 13.6572,
    width: 66.4419,
    height: 105.116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.239216 0 0 0 0 0.121569 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 12.1387,
    y: 26.269,
    width: 57.461,
    height: 88.7396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.443137 0 0 0 0 0.231373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 25.1084,
    y: 54.7207,
    width: 31.1642,
    height: 58.0405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 30.3525,
    y: 74.4717,
    width: 20.6788,
    height: 37.3368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8616 62.2149) rotate(-76.3717) scale(35.5684 23.6294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83D1F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.9429,
    height: 117.25,
    fill: "white",
    transform: "translate(0.897461 0.483887)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfirePoints5);
export default __webpack_public_path__ + "static/media/campfire-points-5.bd6172952d9df9336ea5b3325284269e.svg";
export { ForwardRef as ReactComponent };